import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';
import { Stakeholder } from './types/Stakeholder';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

import { TopNavigationComponent } from './components/top-navigation/top-navigation.component';
import { MobileMainContentComponent } from './components/mobile-main-content/mobile-main-content.component';
import { BottomNavigationComponent } from './components/bottom-navigation/bottom-navigation.component';
import { LeftSideNavigationComponent } from './components/left-side-navigation/left-side-navigation.component';
import { MainContentComponent } from './components/main-content/main-content.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    TopNavigationComponent,
    MobileMainContentComponent,
    BottomNavigationComponent,
    LeftSideNavigationComponent,
    MainContentComponent,
    MatDialogModule
],
})
export class AppComponent implements OnInit, AfterViewInit {
  stakeholder: Stakeholder = {
    FirstName: '',
    LastName: '',
    StakeId: '',
    StakeGuid: '',
  };

  stakeGUID = '';

  isMobile = false;

  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    window.location.href = 'https://i24sechoicelanes-vpm.tdotoutreach.com';
  }

  ngAfterViewInit(): void {
    const gTranslateSettings = document.createElement('script');
    gTranslateSettings.innerHTML = `
    window.gtranslateSettings = {
      "default_language":"en",
      "native_language_names":true,
      "detect_browser_language":true,
      "languages":["en","es","de","vi","fr","am","ru","ko","ar","ne","hi","yo","pt","ja","fa", "zh-CN", "zh-TW", "tl"],
      "wrapper_selector":".gtranslate_wrapper"
      };
    `;
    document.body.appendChild(gTranslateSettings);

    const gTranslateScript = document.createElement('script');
    gTranslateScript.src =
      'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
    gTranslateScript.defer = true;
    document.body.appendChild(gTranslateScript);
  }

  validateRegistration(): void {
    setTimeout(() => {
      this.route.queryParams.subscribe((params) => {
        this.stakeGUID =
          sessionStorage.getItem('stakeGuid') || params['stakeGuid'] || '';

        if (this.stakeGUID) {
          sessionStorage.setItem('stakeGuid', this.stakeGUID);
          const url = new URL(window.location.href);
          url.searchParams.delete('stakeGuid');
          window.history.replaceState({}, '', url.toString());

          this.appService.validateStakeholderGuid(this.stakeGUID).subscribe({
            next: (response: Stakeholder) => {
              this.stakeholder = response;
              this.appService.updateStakeholder(this.stakeholder);
            },
            error: (error) => {
              console.error('Error during validation:', error);
              window.location.href = environment.pimaEventRegistrationUrl;
            },
          });
        } else {
          console.error('No stakeGuid found.');
          window.location.href = environment.pimaEventRegistrationUrl;
        }
      });
    }, 100);
  }

  isReferrerValid(): boolean {
    const referrer = document.referrer;

    if (
      referrer.includes(environment.pimaOrigin) ||
      referrer.includes(window.location.origin)
    ) {
      return true;
    } else {
      return false;
    }
  }
}
